module.exports = __webpack_public_path__ + "img/cheveron-down-icon.22d20650.svg";